<template>
  <div class="tabs_content" id="tab">
    <section>
      <div class="filter search_only">
        <div class="field_left">
          <p class="field">
            <label for="vyhledavani" v-translate>Vyhledávání</label>
            <input class="search clearable" id="vyhledavani" name="vyhledavani" size="30" v-model="searchText"
                   type="text">
            <a @click="clearFilter" id="vyhledavani_delete" class="clearable_btn" :title="$gettext('Vymazat text')"
               :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
          </p>
        </div>
      </div>
      <div class="table_overflow">
        <table class="vypis">
          <thead>
          <tr v-if="filteredUsers.length > 0">
            <th class="no_padding drag_drop"></th>
            <th class="no_padding checkbox"></th>
            <th><span class="name"><strong v-translate>Přihlašovací jméno</strong></span></th>
            <th><span v-translate>Jméno</span></th>
            <th><span class="name"><strong v-translate>Operátor</strong></span></th>
          </tr>
          </thead>
          <tbody>
          <users-row
              v-for="item in filteredUsers"
              :entity="item"
              :key="item.id"
              :selectedEntities="selectedEntities"
              @input="select" />
          <tr v-if="filteredUsers.length === 0">
            <td colspan="5" v-translate>Nebyli nalezeni žádní uživatelé.</td>
          </tr>
          </tbody>
        </table>
      </div>
      <local-list-action-line
          :entities="filteredUsers"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import localTable from "@/components/mixins/local-table";
import UsersRow from "./UsersRow";

export default {
  name: "Users",
  components: {UsersRow},
  mixins: [localTable],
  props: {
    entity: Object,
  }, data() {
    return {
      searchText: ""
    };
  },
  methods: {
    clearFilter() {
      this.searchText = "";
    },
  },
  computed: {
    entities() {
      return Object.values(this.filteredUsers);
    },
    csvHeaders() {
      return {
        'login': {name: this.$gettext('Přihlašovací jméno')},
        'name': {name: this.$gettext('Jméno')},
        'operator': {name: this.$gettext('Operátor')},
      };
    },
    filteredUsers() {
      if (!this.searchText) {
        return this.entity.users;
      }

      let searchText = this.searchText.toLowerCase();

      return this.entity.users.filter((item) => {
        return item.name.toLowerCase().includes(searchText) ||
            item.login.toLowerCase().includes(searchText) ||
            (item.operator && item.operator.toLowerCase().includes(searchText));
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/detail/Users.vue